import { AppropriationsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from '@/lib/clients/apiConfigs'

export const appropriationsClient = new AppropriationsApi(ecomConfiguration)
